
import { mapState, mapGetters } from "vuex";
import { Component, Vue, Watch } from "vue-property-decorator";
import GroepsFilter from "@/components/EventRegistration/GroepsFilter.vue";
import AudienceFilter from "@/components/EventRegistration/AudienceFilter.vue";
import InterestAreaFilter from "@/components/EventRegistration/InterestAreaFilter.vue";
import SubjectFilter from "@/components/EventRegistration/SubjectFilter.vue";
import DatumFilter from "@/components/EventRegistration/DatumFilter.vue";
import BuildingFilter from "@/components/EventRegistration/BuildingFilter.vue";
import StudyLanguageFilter from "@/components/EventRegistration/StudyLanguageFilter.vue";
import StudyTypeFilter from "@/components/EventRegistration/StudyTypeFilter.vue";
import StudyFormFilter from "@/components/EventRegistration/StudyFormFilter.vue";
import SearchFilter from "@/components/EventRegistration/SearchFilter.vue";
import SessionList from "@/components/EventRegistration/SessionList.vue";
import SelectedSessions from "@/components/EventRegistration/SelectedSessions.vue";
import Session from "@/models/Session";
import Event from "@/models/Event";
import * as Moment from "moment";
import moment from "moment";
import { extendMoment } from "moment-range";


@Component({
  components: {
    GroepsFilter,
    AudienceFilter,
    InterestAreaFilter,
    SubjectFilter,
    DatumFilter,
    BuildingFilter,
    StudyLanguageFilter,
    StudyTypeFilter,
    StudyFormFilter,
    SearchFilter,
    SelectedSessions,
    SessionList
  },
  computed: {
    ...mapState("EventRegistration", [
      "loading",
      "selectedSessions",
      "loadingSessions",
      "event",
      "choossenGroepsGrootte"
    ]),
    ...mapGetters("EventRegistration", ["Event", "SessionDatesLength", "FilterdParentSessionsCount"])
  }
})
export default class EventRegistration extends Vue {
  currentStep = 1;
  showAlert = false;
  eventIsFinished = false;
  alertText = "";
  showMessage = false;
  messageText = "";
  numberOfSelectedSessions = 0;
  dialog = false;
  mobile = false;
  windowWidth = 2000;

  data() {
    return {
      windowWidth: window.innerWidth
    }
  }
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth
      this.mobile = this.windowWidth < 700;
    }
  }

  hideAlert() {
    this.showAlert = false;
    if (this.alertText == this.$tc("er.groepsgrootte"))
      window.scrollTo(0, 150)
  }

  async created() {

    this.mobile = this.windowWidth < 700;

    if (this.$route.query.hc) {
      this.$store.commit("EventRegistration/vlsChanged", this.$route.query.hc);
    } else {
      this.$store.commit("EventRegistration/vlsChanged", "");
    }
    await this.$store.dispatch("EventRegistration/loadInitialData", {
      eventId: this.$route.query.id,
      ppId: this.$route.query.pp
    });

  }


  removeAllFilters() {

    //remove InterestAreaFilter
    const InterestAreaFilterComponent = this.$refs
      .InterestAreaFilterComponentref as InterestAreaFilter;
    if (InterestAreaFilterComponent) InterestAreaFilterComponent.selected = [];

    //remove DatumFilter
    const DatumFilterComponent = this.$refs
      .DatumFilterComponentref as DatumFilter;
    if (DatumFilterComponent) DatumFilterComponent.selected = [];

    //remove BuildingFilter
    const BuildingFilterComponent = this.$refs
      .BuildingFilterComponentref as BuildingFilter;
    if (BuildingFilterComponent) BuildingFilterComponent.selected = [];

    //remove StudyTypeFilter
    const StudyTypeFilterComponent = this.$refs
      .StudyTypeFilterComponentref as StudyTypeFilter;
    if (StudyTypeFilterComponent) StudyTypeFilterComponent.selected = [];

    //remove StudyForm
    const StudyFormFilterComponent = this.$refs
      .StudyFormFilterComponentref as StudyFormFilter;
    if (StudyFormFilterComponent) StudyFormFilterComponent.selected = [];

    //remove StudyChoice
    const StudyChoiceFilterComponent = this.$refs
      .StudyChoiceFilterComponentref as SubjectFilter;
    if (StudyChoiceFilterComponent) StudyChoiceFilterComponent.selected = [];


    //remove StudyLanguageFilter
    const studyLanguagefilter = this.$refs
      .StudyLanguageFilterComponentref as StudyLanguageFilter;
    if (studyLanguagefilter) studyLanguagefilter.selected = [];

    this.$store.commit("EventRegistration/filterChanged", {
      type: "Audiences",
      values: []
    });

    this.$store.commit("EventRegistration/recalculateFilters");
  }

  recalculateFilters() {
    this.$store.commit("EventRegistration/recalculateFilters");
  }

  @Watch("selectedSessions", { immediate: true })
  selectedSessionsChanged(sessionIds: string[]) {
    this.numberOfSelectedSessions = sessionIds.length;
  }

  @Watch("event", { immediate: true })
  async eventChanged(event: Event) {
    const eventImage = document.getElementById(
      "eventImage"
    ) as HTMLImageElement;

    if (event.name != "Loading") {
      if (event.name.includes("Liquid")) {
        window.location.replace("https://www.han.nl/eventnotfound");
      }

      document.title = event.name + " - HAN University of Applied Sciences";
      eventImage.src = event.image;

      if (this.eventFinished(event) == true) {
        this.eventIsFinished = true;
      } else {
        try {
          await this.$store.dispatch("EventRegistration/loadSessionData", {
            eventId: this.$route.query.id,
            ppId: this.$route.query.pp,
            max: event.nrOfSesions < 50 ? 99999 : 10,
            language: this.$i18n.locale,
            vls: this.$route.query.hc
          });
          this.$store.commit("EventRegistration/setFilter");
        } catch (error) {
          this.showAlert = true;
          this.alertText = error.message;
        }

      }
    }
  }

  @Watch("choossenGroepsGrootte", { immediate: true })
  async ClearGroepsGrootteMessage(groepsGrootte: number) {
    if (this.showAlert) {
      this.showAlert = groepsGrootte < 1;
    }
  }

  eventFinished(event: Event): boolean {
    if (event.setregistrationsenddate.toString() == "true") {
      const eventEndDate = new Date(event.stopwebsiteregistrationson);
      return moment().isAfter(eventEndDate);
    }
    return false;
  }

  alertForCancelRegistration() {
    this.showMessage = true;
    this.messageText = "Weet je zeker dat je jouw aanmeldig wilt annuleren? <br/>  Klik dan op OK.";
  }

  cancelregistratie() {
    location.href = "cancelregistratie/?id=" + this.$route.query.pp;
  }

  changeStep(stepnr: number) {
    const entityform = document.getElementById("entityform") as HTMLDivElement;
    const sessionsPanel = document.getElementById("sessions") as HTMLDivElement;

    if (stepnr == 2) {
      if (this.eventFinished(this.$store.state.EventRegistration.event)) return;

      if (this.numberOfSelectedSessions < 1) {
        this.showAlert = true;
        this.alertText = this.$tc("er.minimumSessions");
        return;
      }
      if (this.nextButtonDisabled) {
        //  Er zijn sessies met tijd overlap
        this.showAlert = true;
        this.alertText = this.$tc("er.timeoverlap");
        return;
      }

      if (this.$store.state.EventRegistration.event.maxgroepsregistratie > 1 &&
        this.$store.state.EventRegistration.choossenGroepsGrootte < 1) {
        this.showAlert = true;
        this.alertText = this.$tc("er.groepsgrootte");
        return;
      }
      if (
        this.$store.state.EventRegistration.event.maxSessionRegistrations > 0 &&
        this.numberOfSelectedSessions >
        this.$store.state.EventRegistration.event.maxSessionRegistrations
      ) {
        this.showAlert = true;
        this.alertText = this.$tc("er.maxSessions").replace(
          "##",
          this.$store.state.EventRegistration.event.maxSessionRegistrations
        );
        return;
      }

      this.currentStep = 2;
      if (this.$store.state.EventRegistration.portalProcessing) {
        Vue.$cookies.set(
          "SelectedSessionIds",
          this.$store.state.EventRegistration.selectedSessions.join(",")
        );

        Vue.$cookies.set(
          "groepsgrootte",
          this.$store.state.EventRegistration.choossenGroepsGrootte
        );
        location.href = "editregistratie/?pp=" + this.$route.query.pp;
      }

      sessionsPanel.style.display = "none";
      entityform.style.display = "block";
      window.scrollTo(0, 0)
    }
    if (stepnr == 1) {
      this.currentStep = 1;

      sessionsPanel.style.display = "block";
      entityform.style.display = "none";
    }
  }

  get cancelButtonVisible() {
    if (this.$route.query.pp) {
      if (this.$store.state.EventRegistration.selectedSessions.length == 0) {
        switch (this.$store.state.EventRegistration.event.eventtype) {
          case "806970013":
          case "806970015":
          case "806970016":
            return true;
          default:
            return false;
        }
        return true;
      }
    }
    return false;
  }

  get nextButtonDisabled() {
    if (this.$store.state.EventRegistration.selectedSessions.length == 0)
      return true;

    if (this.eventFinished(this.$store.state.EventRegistration.event))
      return true;

    const extMoment = extendMoment(Moment);
    const selSessions =
      this.$store.state.EventRegistration.selectedSessions.map((id: string) => {
        return this.$store.state.EventRegistration.sessionsById[id];
      });
    const selSessionsWithTimeCheck =
      this.$store.state.EventRegistration.selectedSessions
        .map((id: string) => {
          return this.$store.state.EventRegistration.sessionsById[id];
        })
        .filter((s: Session) => s.tijdscontrole == true);


    if (selSessionsWithTimeCheck.length == 0) return false;

    let outSideRange = true;
    for (let index = 0; index < selSessionsWithTimeCheck.length; index++) {
      const session = selSessionsWithTimeCheck[index];
      const sessionRange = extMoment.range(
        new Date(session.start),
        new Date(session.end)
      );

      selSessionsWithTimeCheck.forEach((s: Session) => {
        if (s.id != session.id) {
          const sRange = extMoment.range(new Date(s.start), new Date(s.end));
          outSideRange =
            outSideRange && !sessionRange.overlaps(sRange, { adjacent: false });
        }
      });
    }
    return !outSideRange;
  }

  IsUsedForThisType(filter: string) {

    let filterOptions = ["Audience", "Building", "Date", "StudyForm", "StudyLanguage", "StudyType", "Interest",  "Subject"];

    switch (this.$store.state.EventRegistration.event.eventtype) {
      case "806970012":
        filterOptions = ["StudyType"];
        break;
      case "806970011":
      case "806970013":
      case "806970014":
      case "806970015":
        filterOptions = ["Building", "Date", "StudyLanguage", "Interest", "Audience"];
        break;
      case "806970016":
        filterOptions = ["Building", "Date", "StudyLanguage", "Interest", "Subject"];
        break;
    }
    return filterOptions.includes(filter);
  }

  GetEventFinishedMessage() {
    if (this.$store.state.EventRegistration.event.websitemessage)
      return this.$store.state.EventRegistration.event.websitemessage;
    else
      return this.$t("er.eventFinished");
  }


}
